import React, { useEffect, useState } from "react";
import styles from "./index.module.scss";
import BreadCrumbs from "../components/Breadcrumbs";
import HeroSection from "../components/ChartDataHeroSection";
import useChartDataQuery, {
	ChartDataContext,
} from "../hooks/useChartDataQuery";
import DetailSection from "../components/ChartDataDetailSection";
import ChartDataSearchBox from "../components/ChartDataSearchBox";
import BackToTopButton from "../components/BackToTopButton";
import { Link } from "react-router-dom";

const breadcrumbsValue = [
	{
		href: "/statistics/ChishangEarthquake",
		text: "0918 池上地震-花東地區地震認知與避難行為調查 (2023)",
	},
	{ href: "/statistics/ChishangEarthquake/chart-data", text: "主題圖表" },
];

function ChartDataPage() {
	const [backToTopIsVisible, setbackToTopIsVisible] = useState(false);

	useEffect(() => {
		window.scrollTo(0, 0);

		const handleScroll = () => {
			if (window.scrollY > 20) {
				setbackToTopIsVisible(true);
			} else {
				setbackToTopIsVisible(false);
			}
		};

		window.addEventListener("scroll", handleScroll);
		return () => window.removeEventListener("scroll", handleScroll);
	}, []);

	const chartDataQuery = useChartDataQuery();

	const handleBackToTop = () => {
		window.scrollTo({
			top: 0,
			behavior: "smooth",
		});
	};
	return (
        <ChartDataContext.Provider value={chartDataQuery}>
            <div className={styles.chartDataPage}>
                <div className={styles.breadcrumbsBlock}>
                    <div className={styles.breadcrumbs}>
                        {/* <Link to="/statistics/ChishangEarthquake">
                            <span>
                                0918 池上地震-花東地區地震認知與避難行為調查
                                (2023)
                            </span>
                        </Link>
                        <span className={styles.breadcrumbsSeparator}>
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="12"
                                height="12"
                                viewBox="0 0 12 12"
                                fill="none"
                            >
                                <line
                                    x1="11.6036"
                                    y1="0.728553"
                                    x2="0.996952"
                                    y2="11.3352"
                                    stroke="#5B5B5B"
                                />
                            </svg>
                        </span>
                        <span>
                            <b>主題圖表</b>
                        </span> */}
                    </div>
                    <div className={styles.chartDataCTA}>
                        <Link
                            to="/statistics/ChishangEarthquake/custom-data-tutorial"
                            className={styles.chartDataLink}
                        >
                            前往客製化專區
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                            >
                                <path
                                    d="M10 8L14 12L10 16"
                                    stroke="#A479E9"
                                    strokeWidth="2"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                            </svg>
                        </Link>
                    </div>
                </div>
                <HeroSection />
                <section className={styles.pageDescription}>
                    <p>
                        本區提供「0918池上地震調查」數據的視覺化結果，涵蓋震前防減災、震時應變與震後損失的統計數據。
                        使用者可瀏覽各項調查成果，並下載相關圖表與數據做進一步應用。
                    </p>
                </section>
                <ChartDataSearchBox />
                <DetailSection />
                <BackToTopButton
                    className={`${styles.backToTop} ${
                        !backToTopIsVisible && styles.hidden
                    }`}
                    onClick={handleBackToTop}
                />
            </div>
        </ChartDataContext.Provider>
    );
}

export default ChartDataPage;
